const professionalName = document.querySelector('h1').textContent;
const nameParts = [
    professionalName.split(' ')[0],
    professionalName.split(' ').slice(1).join(' '),
];
const splitLoadedClass = 'split-loaded';
const loadedClass = 'landing-loaded';

document.querySelectorAll('.diag-split').forEach((diag, index) => {
    const splitDiv = document.createElement('div');

    splitDiv.classList.add('split-name');
    splitDiv.textContent = nameParts[index];

    diag.appendChild(splitDiv);
});

const $splitName = document.querySelector('.split-name');

const adjustSplitNamePosition = () => {
    document.documentElement.style.setProperty(
        '--vh',
        window.innerHeight * 0.01 + 'px',
    );

    // Top is 0
    // 100% is 12vh
    const windowHeight = window.innerHeight;
    const percentageFromTop =
        (windowHeight - $splitName.offsetTop) / windowHeight;
    const percentageFromBottom = 1 - percentageFromTop;
    const rightPos = percentageFromBottom * (windowHeight * 0.12);

    $splitName.style.transform = 'translateX(calc(-100% - ' + rightPos + 'px))';

    if (!document.body.classList.contains(splitLoadedClass)) {
        setTimeout(() => {
            document.body.classList.add(splitLoadedClass);

            setTimeout(() => {
                document.body.classList.add(loadedClass);
            }, 1000);
        }, 300);
    }
};

const highlightSentence = () => {
    const headshot1El = document.getElementById('headshot-1');
    const sampleSpan = headshot1El.querySelector('span');
    const sentenceHeight = sampleSpan.offsetHeight + 6;

    const windowHeight = window.innerHeight;
    const halfHeight = windowHeight / 2;
    const halfway = Math.round(halfHeight / sentenceHeight) * sentenceHeight;

    const buffer = 30;

    let foundIt = false;

    const highlighted = headshot1El.querySelector('.highlighted');

    if (highlighted) {
        highlighted.classList.remove('highlighted');
    }

    headshot1El.querySelectorAll('span').forEach((span, index) => {
        if (span.offsetLeft > 100 || foundIt) {
            return;
        }

        if (
            span.offsetTop >= halfway - buffer &&
            span.offsetTop <= halfway + buffer
        ) {
            span.classList.add('highlighted');
            foundIt = true;
        }
    });

    if (!foundIt) {
        headshot1El.querySelectorAll('span').forEach((span, index) => {
            if (index === 0 || span.offsetLeft > 100 || foundIt) {
                return;
            }

            span.classList.add('highlighted');
            foundIt = true;
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        highlightSentence();
    }, 1000);
    window.addEventListener('resize', highlightSentence);
});

setTimeout(adjustSplitNamePosition, 10);
window.addEventListener('resize', adjustSplitNamePosition);
